module.exports = __webpack_public_path__ + "img/ThatBrandLogo.60087c06.jpg";